import { Text } from 'common-components'
import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Content = styled.div``

export const PromptHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;

  svg {
    width: 14px;
    height: 14px;
    fill: ${COLORS.secondary};
  }

  svg {
    &:hover * {
      fill: ${COLORS.secondarySemiDark};
    }
    &:active * {
      fill: ${COLORS.secondaryDark};
    }
  }
`

export const PromptText = styled(Text)`
  width: 100%;
  margin: 4px 0 16px 0;
  line-height: 1.2;
`

export const ModelAndQuality = styled.div`
  width: 100%;
  height: 26px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
`

export const MetaChip = styled.div`
  padding: 4px 10px;
  background-color: #f5fafe;
  border-radius: 4px;
  white-space: nowrap;
`

export const ReferenceImages = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RefImages = styled.div`
  width: 100%;
  height: 40px;
  max-width: 270px;
  overflow: hidden;
  overflow-x: auto;
  display: flex;
  gap: 4px;
`

export const RefImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
`
